module.exports = __webpack_public_path__ + "img/W-G05.a5f965e4.jpg";